import { default as api } from '../../utils/api'
import global from '../../components/global'

const dictData = {
    state: {
        dicts: {}
    },
    mutations: {
        PUSH_DICT: (state, elems) => {
            if(elems instanceof Array){
                elems.forEach(function(item){
                    if(!state.dicts[item.type]){
                        state.dicts[item.type] = [];
                    }
                    state.dicts[item.type].push(item);
                });
            }
        },
        RESET_DICT: (state) => {
            state.dicts = {};
        }
    },
    actions: {
        // 获取用户信息
        GetDictData({ commit, state }) {
            return new Promise((resolve, reject) => {
                api({
                    url: global.host + '/dict/allList',
                    method: 'get',
                }).then(data => {
                    if (data.result) {
                        //储存字典信息
                        commit('RESET_DICT');
                        commit('PUSH_DICT',data.data.list);
                    } else {

                    }
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}
export default dictData


// WEBPACK FOOTER //
// ./src/store/modules/dict.js